import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `LineaGenetica/getFiltrarLinea`, method: 'POST', body: values, token: token})
}
